import Link from "next/link";
import classNames from "classnames";

export default function AntipiracySnipe({ wide }) {
  return (
    <div
      className={classNames(
        "flex items-center leading-6 bg-blue-500 text-white px-6 py-4 rounded-lg",
        wide ? "text-base" : "max-w-2xl"
      )}
    >
      <span className="bg-blue-700 text-white rounded font-bold px-3 py-1 mr-5 sm:block hidden">
        NEW
      </span>
      <span className="text-left">
        Introducing Eventive Advanced Antipiracy, the most rigorous and
        affordable content security program for film streaming ever deployed.{" "}
        <Link href="/antipiracy">
          <a
            className={classNames(
              "font-bold text-white hover:text-gray-200 inline-flex items-center",
              wide ? "sm:ml-3" : "sm:ml-2"
            )}
          >
            Learn more →
          </a>
        </Link>
      </span>
    </div>
  );
}
